import { useUsageDaily } from '@/lib/walletHooks';
import { formatCurrencyEurRo } from '@/lib/format';
import { buildUsageBars } from './format';

export function UsageChart() {
  const { data, isPending, isError } = useUsageDaily();
  if (isPending) return <div className="h-[172px] animate-pulse rounded-2xl bg-wash" aria-hidden />;
  if (isError || !data) return <p className="text-[13.5px] text-bad">Nu s-a putut încărca graficul.</p>;
  const bars = buildUsageBars(data.days);
  const max = Math.max(...bars.map((b) => b.burnEur), 0);
  return (
    <>
      <div className="relative h-28" role="img" aria-label="Consum zilnic în ultimele 30 de zile">
        {/* Faint reference grid — decorative only, sits behind the bars. */}
        <div className="pointer-events-none absolute inset-0 flex flex-col justify-between" aria-hidden>
          <span className="border-t border-rule-soft" />
          <span className="border-t border-rule-soft" />
          <span className="border-t border-rule-soft" />
          <span className="border-t border-rule-soft" />
        </div>
        <div className="relative flex h-full items-end gap-[3px]">
          {bars.map((b) => (
            <div
              key={b.date}
              className={`flex-1 rounded-sm ${b.isPeak ? 'bg-teal' : 'bg-teal-wash'}`}
              style={{ height: `${Math.max(b.heightPct, 2)}%` }}
              title={`${b.date}: ${formatCurrencyEurRo(b.burnEur)}`}
            />
          ))}
        </div>
      </div>
      <div className="mt-2 flex justify-between text-[12.5px] tabular-nums text-ink-3">
        <span>{bars[0]?.date}</span>
        <span>max {formatCurrencyEurRo(max)}</span>
        <span>{bars[bars.length - 1]?.date}</span>
      </div>
    </>
  );
}
